import { render, staticRenderFns } from "./m-dialog-content.vue?vue&type=template&id=ba17e620&lang=pug"
import script from "./m-dialog-content.vue?vue&type=script&lang=js"
export * from "./m-dialog-content.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports